import { useState, useEffect } from 'react'

export const useMediaQuery = (
  query: string,
  defaultValue: boolean = false,
): boolean => {
  // Initialize with a function to get the correct value immediately on client
  const [matches, setMatches] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches
    }
    return defaultValue
  })

  useEffect(() => {
    const media = window.matchMedia(query)

    // Update state if it's different from current
    if (media.matches !== matches) {
      setMatches(media.matches)
    }

    // Create event listener
    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    // Add listener
    media.addEventListener('change', listener)

    // Cleanup
    return () => media.removeEventListener('change', listener)
  }, [query, matches])

  return matches
}
